import { render, staticRenderFns } from "./BlockColors.vue?vue&type=template&id=7d42ea9a&name=block-colors&"
import script from "./BlockColors.vue?vue&type=script&lang=js&"
export * from "./BlockColors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports